import React from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';

import Heading from '@marvelapp/marvel-ui/heading';
import Spacing from '@marvelapp/marvel-ui/spacing';

import devSidebarLinks from 'marketing-website/configs/devSidebarLinks.js';
import NavDropdown from './NavDropdown';

function Sidebar({ location }) {
  function itemIsActive(item) {
    const itemPaths = urlPaths(item.url);
    const currentPaths = urlPaths(location.pathname);

    // Example: developers/documentation/[current path]
    if (itemPaths[2] === currentPaths[2]) {
      return true;
    }

    return false;
  }

  function urlPaths(url) {
    const noHashUrl = url.replace(/(#.+?)$/, '?var=1$1');
    const slitUrl = noHashUrl.split('/');
    const removeEmptyValues = slitUrl.filter(e => e);
    return removeEmptyValues;
  }

  return (
    <div>
      <Heading tag="h5" weight="normal" size="s" color="silver">
        Contents
      </Heading>
      <Spacing type="padding" position="top" size="m">
        {devSidebarLinks.map(item => (
          <NavDropdown
            key={item.id}
            items={item.items}
            title={item.title}
            url={item.url}
            type={item.type}
            active={itemIsActive(item)}
          />
        ))}
      </Spacing>
    </div>
  );
}

export default withRouter(Sidebar);

Sidebar.propTypes = {
  location: PropTypes.object.isRequired,
};



// WEBPACK FOOTER //
// ./src/components/modules/Sidebar/index.js